/* ============================================================
   Redesign PDP behaviour (vanilla JS).
   Coexists with the legacy product-new.js, which handles the
   actual add-to-cart AJAX by reading the SAME hooks we render:
     - variant: div.select select  OR  input[name="id"]
     - quantity: input#quantity (+ mirrored #mobile_quantity)
     - add-ons: .add-ons-wrap .sub-pro.selected[data-vid][data-price]
     - submit: form.shopify-product-form
   This file owns the live UI: gallery swap, qty stepper, read-more,
   add-on toggle/filter/counter, grand-total + breakdown + sticky bar.
   It defines a GLOBAL updateTotalPrice() that product-new.js calls.
   ============================================================ */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var root = $('[data-rds-pdp]');
  if (!root) return;

  var BASE_PRICE = parseInt(root.getAttribute('data-base-price'), 10) || 0; // cents
  var MONEY_FORMAT = root.getAttribute('data-money-format') || 'RM {{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    var v = (cents / 100);
    var str = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2);
    return 'RM ' + str;
  }

  /* ---- availability (sold-out gating) ----
     Reads data-available written by the Liquid template: the selected <option>
     for multi-variant products, the hidden input[name=id] for single-variant. */
  function selectedIsAvailable() {
    var sel = $('div.select select[name="id"]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return !opt || opt.getAttribute('data-available') !== 'false';
    }
    var hidden = $('input[name="id"]');
    return !hidden || hidden.getAttribute('data-available') !== 'false';
  }

  function syncAvailability() {
    var ok = selectedIsAvailable();
    $all('button.product_add_to_cart').forEach(function (btn) {
      btn.disabled = !ok;
      btn.classList.toggle('is-soldout', !ok);
      if (ok) { btn.removeAttribute('aria-disabled'); } else { btn.setAttribute('aria-disabled', 'true'); }
      var label = btn.querySelector('.add_to_button_pro');
      if (label) label.textContent = ok ? 'Add to cart' : 'Sold out';
      var price = btn.querySelector('[data-rds-grandtotal]');
      if (price) price.style.display = ok ? '' : 'none';
    });
    var stepper = $('.rds-stepper');
    if (stepper) stepper.style.display = ok ? '' : 'none';
    var note = $('.rds-soldout-note');
    if (note) note.style.display = ok ? 'none' : '';
  }

  /* ---- variant + quantity ---- */
  function variantPriceCents() {
    var sel = $('div.select select[name="id"]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.getAttribute('data-price-no-format')) {
        return parseInt(opt.getAttribute('data-price-no-format'), 10) || BASE_PRICE;
      }
    }
    return BASE_PRICE;
  }
  function getQty() {
    var q = $('#quantity');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }
  function setQty(n) {
    n = Math.max(1, n);
    var q = $('#quantity');
    var mq = $('#mobile_quantity');
    if (q) q.value = n;
    if (mq) mq.value = n;
    var disp = $('[data-rds-qty]');
    if (disp) disp.textContent = n;
    updateTotalPrice();
  }

  /* ---- add-ons ---- */
  function selectedAddons() {
    return $all('.add-ons-wrap .sub-pro.selected');
  }
  function addonsTotalCents() {
    return selectedAddons().reduce(function (sum, el) {
      return sum + (parseInt(el.getAttribute('data-price'), 10) || 0);
    }, 0);
  }

  /* ---- the global the legacy script expects ---- */
  window.updateTotalPrice = function updateTotalPrice() {
    var base = variantPriceCents() * getQty();
    var addons = addonsTotalCents();
    var grand = base + addons;
    var count = selectedAddons().length;

    var grandStr = formatMoney(grand);
    $all('[data-rds-grandtotal]').forEach(function (el) { el.textContent = grandStr; });

    console.log("grandStr", grandStr)

    // counter chip
    var chipCount = $('[data-rds-addon-count]');
    var chipLabel = $('[data-rds-addon-summary]');
    if (chipCount) chipCount.textContent = count;
    if (chipLabel) chipLabel.textContent = count === 0 ? 'Nothing added yet' : 'added · ' + formatMoney(addons);

    // breakdown line
    var bd = $('[data-rds-breakdown]');
    if (bd) {
      if (count === 0) {
        bd.style.display = 'none';
      } else {
        bd.style.display = '';
        bd.textContent = 'Bunch ' + formatMoney(base) + ' + ' + count + (count === 1 ? ' add-on ' : ' add-ons ') + formatMoney(addons);
      }
    }

    // sticky sub-label
    var sub = $('[data-rds-sticky-sub]');
    if (sub) {
      sub.textContent = count === 0
        ? formatMoney(variantPriceCents()) + ' · add a treat below'
        : count + (count === 1 ? ' add-on' : ' add-ons') + ' · ' + formatMoney(addons);
    }
  };
  var updateTotalPrice = window.updateTotalPrice;

  /* ============================================================
     Wire up on DOM ready
     ============================================================ */
  function init() {
    /* Gallery thumbnail swap */
    var mainImg = $('[data-rds-main-img]');
    $all('[data-rds-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-img');
        if (mainImg && src) mainImg.src = src;
        $all('[data-rds-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        // keep sticky-bar thumb in sync
        var st = $('[data-rds-sticky-img]');
        if (st && src) st.src = src;
      });
    });

    /* Quantity stepper */
    var dec = $('[data-rds-qty-dec]');
    var inc = $('[data-rds-qty-inc]');
    if (dec) dec.addEventListener('click', function () { setQty(getQty() - 1); });
    if (inc) inc.addEventListener('click', function () { setQty(getQty() + 1); });
    var qInput = $('#quantity');
    if (qInput) qInput.addEventListener('change', function () { setQty(getQty()); });

    /* Read more / less */
    var moreBtn = $('[data-rds-readmore]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var more = $('[data-rds-desc-more]');
        var expanded = root.classList.toggle('rds-desc-open');
        if (more) more.style.display = expanded ? '' : 'none';
        moreBtn.textContent = expanded ? 'Read less' : 'Read more';
      });
    }

    /* Add-on toggle */
    $all('.add-ons-wrap .sub-pro').forEach(function (card) {
      var btn = card.querySelector('[data-rds-addon-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var on = card.classList.toggle('selected');
        var cb = card.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = on;
        btn.textContent = on ? '✓ Added' : '+ Add';
        updateTotalPrice();
      });
    });

    /* Category pill filter */
    $all('[data-rds-cat]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.getAttribute('data-rds-cat');
        $all('[data-rds-cat]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        $all('.add-ons-wrap .sub-pro').forEach(function (card) {
          var cats = card.getAttribute('data-cats') || '';
          var show = (cat === 'all') || (cats.split(' ').indexOf(cat) !== -1);
          card.style.display = show ? '' : 'none';
        });
      });
    });

    /* Variant change → price + image */
    var sel = $('div.select select[name="id"]');
    if (sel) {
      sel.addEventListener('change', function () {
        updateTotalPrice();
        syncAvailability();
        var opt = sel.options[sel.selectedIndex];
        var img = opt && opt.getAttribute('data-image');
        if (img && mainImg) mainImg.src = img;
      });
    }

    /* Variant pills drive the hidden <select> (which the change handler above reacts to) */
    var variantPills = $all('.rds-variant-pill');
    variantPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var id = pill.getAttribute('data-variant-id');
        if (!sel || !id) return;
        sel.value = id;
        variantPills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Add to cart — replicates legacy product-new.js flow without its coupling:
       add selected add-ons via /cart/add.js, then submit the product form. */
    var productForm = $('form.shopify-product-form');
    function submitProductForm() {
      if (productForm) productForm.submit();
    }
    $all('button.product_add_to_cart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || !selectedIsAvailable()) return;
        btn.disabled = true;
        var label = btn.querySelector('.add_to_button_pro');
        var prev = label ? label.textContent : '';
        if (label) label.textContent = 'Adding…';

        var items = selectedAddons().map(function (el) {
          return { quantity: 1, id: parseInt(el.getAttribute('data-vid'), 10) };
        });

        if (items.length) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () {
            submitProductForm();
          }).catch(function () {
            btn.disabled = false;
            if (label) label.textContent = prev;
          });
        } else {
          submitProductForm();
        }
      });
    });

    updateTotalPrice();
    syncAvailability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
